/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface HostInfo {
  fullMem: boolean;
  acceptingUploads: boolean;
  serverFreeMemory?: number;
  serverUptime?: number;
  serviceUptime?: number;
  avgLoad?: number;
  numPeers: number;
  currency: string;
  costPerMonth: number;
  uri: string;
  runningContracts?: number;
  peers?: string[];
  selfTestSuccess?: boolean;
}
